export default __webpack_public_path__ + "static/zaidi-958a544e6bc37a66e1e6972d6c3e6dee.png";